<template>
  <div>
    <div>
      
      <el-form
        :inline="true"
        :model="extendedForm"
        style="text-align:left;"
        label-width="100px"
        class="extendedForm"
      >
      <!--  -->
        <el-row>
          <el-col :span="8">
            <el-form-item label="导入模板">
              <el-button type="primary" @click="downEx">下载</el-button>
              <!-- <el-button type="primary">
                <a href="https://sskx-fs-1259667406.cos.ap-beijing.myqcloud.com/uip/2021/07/13/sskx_fa43d67c343c2fbb67a85f2475b5ee38.xlsx" style="text-decoration:none;color:#fff;" download="下载.xlsx">下载</a>
              </el-button> -->
              
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <div style="display: flex;flex-direction: row;">
              <div style="font-size:16px;margin-top:10px;">上传:</div>
              <el-form-item label="机构:">
                <el-select :placeholder="wfPlaceholder"  v-model="ageForm.agentBranName" :clearable='true' filterable @change="changeWfSelct">
                  <el-option v-for="item in wfAgentBranchList" :key="item.agentBranCode" :label="item.agentBranName"  :value="item.agentBranName"></el-option> 
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <el-upload
              class="upload-demo"
              ref="upload"
              :data="upData"
              :httpRequest="httpRequest"
              action="/extwarapi/api/extensionPolicy/importExtensionOrder"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-success="handleSuccess"
              :on-error="handleError"
              :on-progress="handleProgress"
              :file-list="fileList"
              :auto-upload="false">
              <el-button slot="trigger" size="small" type="primary" >选取文件</el-button>
              <el-button style="margin-left: 10px;" size="small" type="primary" @click="submitUpload()" >确认导入</el-button>
            </el-upload>
          </el-col>
        </el-row>
        <el-row style="text-align:left;">
          <el-row style="display:flex;text-align:left;">
            <el-checkbox-button :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全部</el-checkbox-button>
            <el-checkbox-group v-model="extendedForm.stateArray" @change="changeStateArray">
              <el-checkbox-button v-for="item in cities" :label="item.label" :key="item.label">{{item.value}}</el-checkbox-button>
            </el-checkbox-group>
          </el-row>
          <!-- <el-radio-group
            v-model="extendedForm.stateArray"
            style="margin-bottom: 10px;"
            @change="changeState"
          >
            <el-radio-button label="ALL">全部</el-radio-button>
            <el-radio-button label="PAY">待支付</el-radio-button>
            <el-radio-button label="SUBMIT">待提交</el-radio-button>
            <el-radio-button label="RESUBMIT">待修改</el-radio-button>
            <el-radio-button label="CHECK">待审核</el-radio-button>
            <el-radio-button label="FILL">待补充</el-radio-button>
            <el-radio-button label="EFFECT">已生效</el-radio-button>
            <el-radio-button label="CLOSE">已失效</el-radio-button>
            <el-radio-button label="CANCEL">已取消</el-radio-button>
          </el-radio-group> -->
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="延保产品名称:">
              <My-Select
                v-model="extendedForm.prodCode"
                :objSelect="extendedForm.prodCode"
                :options="ewProductList"
                :placeholder="ewPlaceholder"
                :optionBind="optionBindEw"
                @changeSelct="changeEwSelct"
                class="select-class-prod"
              ></My-Select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="承销商/销售机构:"
              class="select-class-prod"
              label-width="120px"
              style="margin-left:-18px"
            >
              <el-cascader
                v-model="extendedForm.agent"
                :props="queryOrgan"
                clearable
                filterable
                placeholder="请选择承销商/销售机构"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="销售人员:" class="category-select-sale">
              <My-Select
                v-model="extendedForm.salesLevelCode"
                :objSelect="extendedForm.salesLevelCode"
                :options="salesLevelList"
                :placeholder="salesLevelPlaceholder"
                :optionBind="optionSalesLeve"
                @changeSelct="changeSalesleveSelct"
              ></My-Select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span='8'>
            <el-form-item label="品类:" class="category-select">
              <My-Select
                v-model="extendedForm.dicTypeCode"
                :objSelect="extendedForm.dicTypeCode"
                :options="categoryList"
                :placeholder="categoryPlaceholder"
                :optionBind="optionBindCategory"
                @changeSelct="changeCategorySelct"
              ></My-Select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="品牌:" class="category-select">
              <My-Select
                v-model="extendedForm.dicBrandCode"
                :objSelect="extendedForm.dicBrandCode"
                :options="prodBrandList"
                :placeholder="brandPlaceholder"
                :optionBind="optionBindBrand"
                @changeSelct="changeBrandSelct"
              ></My-Select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="省市区:" class="select-name">
              <el-cascader
                v-model="extendedForm.area"
                :props="queryProps"
                clearable
                filterable
                placeholder="请选择省市区"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="建单时间:" class="date-time">
              <el-date-picker
                v-model="extendedForm.createTimeStart"
                type="datetime"
                size="large"
                placeholder="开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
              <span> - </span>
              <el-date-picker
                v-model="extendedForm.createTimeEnd"
                type="datetime"
                size="large"
                placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                default-time = "23:59:59"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="审核通过时间:"
              class="date-time"
            >
              <el-date-picker
                v-model="extendedForm.passTimeStart"
                type="datetime"
                placeholder="开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
              <span> - </span>
              <el-date-picker
                v-model="extendedForm.passTimeEnd"
                type="datetime"
                placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                default-time = "23:59:59"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="生效时间:"
              class="date-time"
            >
              <el-date-picker
                v-model="extendedForm.effectiveDateStart"
                type="datetime"
                placeholder="开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
              <span> - </span>
              <el-date-picker
                v-model="extendedForm.effectiveDateEnd"
                type="datetime"
                placeholder="结束时间"
                default-time = "23:59:59"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="补充时间:" class="date-time">
              <el-date-picker
                v-model="extendedForm.fillTimeStart"
                type="datetime"
                placeholder="开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
              <span> - </span>
              <el-date-picker
                v-model="extendedForm.fillTimeEnd"
                type="datetime"
                placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                default-time = "23:59:59"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="综合查询:">
              <el-input
                v-model="extendedForm.name"
                placeholder="请输入延保单单号/客户姓名/客户电话/延保销售单号/机械销售单号"
                :clearable="true"
                class="query-input"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" plain @click="query()">查询</el-button>
            <el-button type="primary" plain @click="exportExt()"
              >选中导出</el-button
            >
            <el-button type="primary" plain @click="exportExtAll()"
              >全部导出</el-button
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="销售渠道:">
              <My-Select
                v-model="extendedForm.salesChannels"
                :objSelect="extendedForm.salesChannels"
                :options="salesChannelsProductList"
                :placeholder="salesChannelsPlaceholder"
                :optionBind="optionBindsalesChannels"
                @changeSelct="changesalesChannelsSelct"
                class="select-class-prod"
              ></My-Select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <My-table
        :configurationData="configurationData"
        :operation="operation"
        :getTableParam="getTableParam"
        ref="myTable"
        :showSwitch="showSwitch"
        @selection="getMultipleSelection"
      >
        <!-- @select="getMultipleSelect"
        @allSelection="getMultipleSelection1" -->
        <!-- <template #operation="scope" v-for="(item,idx) in menuList">
          <div  v-if="item.hasSub" :index="item.index" :key="idx" >
            <el-menu-item v-for="sub in item.subItem" :index="sub.route" :key="sub.index" :route="sub.route" >
              <el-button v-show="!scope.row.tertiaryInfo" size="mini" type="text" @click="extendedEditor('appoint',scope.row)">指派</el-button>   
              <el-button v-show="scope.row.state=='CHECK' " size="mini" type="text" @click="extendedEditor('approval',scope.row)">审核</el-button>            
              <el-button v-show="!(scope.row.state=='CLOSE' || scope.row.state=='CANCEL')" size="mini" type="text" @click="extendedEditor('close',scope.row)">关闭</el-button>
            </el-menu-item>
          </div>
        </template>   -->
        <template #operation="scope">
          <!-- <div v-show="buttonKey.operationButton==true"> -->
            <div v-show="buttonKey.appointButton==true">
              <el-button
                v-show="!scope.row.tertiaryInfo"
                size="mini"
                type="text"
                @click="extendedEditor('appoint', scope.row)"
                >指派</el-button
              >
            </div>
            <div v-show="buttonKey.checkButton==true">
              <el-button
                v-show="scope.row.state == 'CHECK'"
                size="mini"
                type="text"
                @click="extendedEditor('approval', scope.row)"
                >审核</el-button
              >
            </div>
            <div v-show="buttonKey.closeButton==true">
            <el-button
              v-show="
                !(scope.row.state == 'CLOSE' || scope.row.state == 'CANCEL') 
              "
              size="mini"
              type="text"
              @click="extendedEditor('close', scope.row)"
              >关闭</el-button
            ></div>
          <!-- </div> -->
        </template>
      </My-table>
    </div>

    <el-dialog
      title="延保单详情"
      :visible.sync="extendedPolicyDetailDialog"
      :close-on-click-modal="false"
      width="1200px"
    >
      <el-row style="text-align: left">
        <el-col :span="22">
          <span>单号:{{ this.orderCode }}</span>
        </el-col>
        <el-col :span="2">
          <span>状态:{{ this.stateName }}</span>
        </el-col>
      </el-row>
      <el-divider class="divider-class"></el-divider>
      <el-form
        :inline="true"
        label-width="100px"
        label-suffix=":"
        style="text-align: left;"
      >
        <div v-for="(item, index) in formList" :key="index">
          <div
            style="margin-left: 30px;font-weight: bold"
            v-if="
              item.propertyInfos.length > 0 && item.propertyName != 'syslayer'
            "
            :class="displayCls(item)"
          >
            {{ item.propertyName }}
          </div>
          
          <div
            style="padding-left: 30px;"
            v-if="
              item.propertyInfos.length > 0 && item.propertyName != 'syslayer'
            "
          >
            <el-row
              v-for="(item1, index1) in item.propertyInfos"
              :key="index1"
            >
            <!-- <div v-if="stateName == '已生效' || stateName == '待补充' || stateName === '已关闭'">
              <el-col :span="12">
                <div
                  v-if="
                    orderPrefixList &&
                    orderPrefixList.rights == 'U' &&
                    orderPrefixList.propertyCode &&
                    orderPrefixList.propertyCode=='100108'&&
                    submitButton==true">
                  <el-form-item :label="getList(item,index1).propertyName">
                    <el-select  @change="changeWfSelct" :placeholder="orderPrefixList.placeholder" v-model="orderPrefixList.propertyValueName" :clearable='true' filterable :disabled="false" @blur="getBlur(orderPrefixList)" style="">
                      <el-option v-for="it in orderPrefixList.data" :key="it.code" :label="it.name"  :value="item.name" ></el-option> 
                    </el-select>
                  </el-form-item>
                </div>
                <div v-else>
                  <Component-Form
                    ref="child"
                    :item="getList(item, index1)"
                    :state="stateName"
                    :submitValue='submitButton'
                    @changeFormValue="childFormValue"
                    :orderPrefix="orderPrefix"
                  ></Component-Form>
                </div>
              </el-col>
              <el-col :span="12">
                <Component-Form
                   ref="child"
                  :item="getList(item, index1 + 1)"
                  :submitValue='submitButton'
                  :state="stateName"
                  @changeFormValue="childFormValue"
                  :orderPrefix="orderPrefix"
                ></Component-Form>
              </el-col>
            </div>
            <div v-else> -->
              <div v-if="index1 % 2 == 0">
                <el-col :span="12">
                  <Component-Form
                    ref="child"
                    :item="getList(item, index1)"
                    :state="stateName"
                    :submitValue='submitButton'
                    @changeFormValue="childFormValue"
                    :orderPrefix="orderPrefix"
                  ></Component-Form>
                </el-col>
                <el-col :span="12">
                  <Component-Form
                    ref="child"
                    :item="getList(item, index1 + 1)"
                    :submitValue='submitButton'
                    :state="stateName"
                    @changeFormValue="childFormValue"
                    :orderPrefix="orderPrefix"
                  ></Component-Form>
                </el-col>
              </div>
            <!-- </div>   -->
            </el-row>
          </div>
        </div>
        <div
          style="margin-left: 30px;font-weight: bold"
          v-if="this.opinionObj != null"
        >
          审核信息
        </div>
        <div style="padding-left: 30px;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="最新审核时间" class="ss-view-item">
                <span>{{ opinionObj.createTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最新审核人员" class="ss-view-item">
                <span>{{ opinionObj.applyUserName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="最新审核原因" class="ss-view-item">
                <span>{{ opinionObj.auditResultsName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最新审核备注" class="ss-view-item">
                <span>{{ opinionObj.remarks }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" style="display:flex;justify-content:center;padding:30px;">
        <div v-show="buttonKey.checkButton==true">
          <el-button
            v-show="this.stateName === '待审核'"
            @click="extendedEditor1('approval')"
            >审核</el-button
          >
        </div>
        <div v-show="submitButton==true">
          <el-button
            v-show="this.stateName === '待补充' || this.stateName === '已生效' || this.stateName === '已关闭'"
            @click="submit">提交</el-button
          >
        </div>
        
        <div>
          <el-button @click="extendedPolicyDetailDialog = false" style="margin-left:30px;">关闭</el-button>
        </div>
        
      </div>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="approvalStateDialog"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-row style="text-align: left">
        <el-col :span="19">
          <span>单号:{{ this.orderCode }}</span>
        </el-col>
        <el-col :span="5">
          <span class="state-class">状态:{{ this.stateName }}</span>
        </el-col>
      </el-row>
      <el-form :model="approvalInfoForm" style="text-align: left">
        <div style="padding-top: 15px" v-show="approvalInfoTag">
          <el-row>
            <el-col :span="16">
              <span>上次审核时间:{{ approvalInfoForm.createTime }}</span>
            </el-col>
            <el-col :span="6">
              <span>上次审核人员:{{ approvalInfoForm.applyUserName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <span>上次驳回原因:{{ approvalInfoForm.reason }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <span>上次审核备注:{{ approvalInfoForm.remarks }}</span>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <el-divider class="divider-class"></el-divider>
      <el-form
        :model="approvalForm"
        :rules="rules"
        ref="approvalForm"
        label-width="100px"
        label-suffix=":"
        style="text-align: left"
        class="approvalForm"
      >
        <div v-show="approvalDialog">
          <el-form-item label="审核结果" prop="auditResults">
            <el-radio-group
              v-model="approvalForm.auditResults"
              @change="changeRadio"
            >
              <el-radio label="pass">审核通过</el-radio>
              <el-radio label="nopass">审核不通过</el-radio>
              <el-radio label="add">补充资料</el-radio>
              <el-radio label="cancel">取消保单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="驳回原因"
            v-show="noPassInformationTag"
            prop="reason"
          >
            <My-Select
              v-model="approvalForm.reason"
              :objSelect="approvalForm.reason"
              :options="reasonList"
              placeholder="请填写驳回原因"
              :optionBind="optionReason"
              @changeSelct="changeReason"
              class="reason-input"
            ></My-Select>
          </el-form-item>
          <el-form-item
            label="审核备注"
            v-show="noPassInformationTag"
            prop="remarks"
          >
            <el-input
              type="textarea"
              maxlength="200"
              rows="5"
              show-word-limit
              v-model="approvalForm.remarks"
              class="textarea-class"
              placeholder="请填写驳回原因"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="补充内容"
            v-show="addInformationTag"
            prop="remarks"
          >
            <el-input
              type="textarea"
              maxlength="200"
              rows="5"
              show-word-limit
              v-model="approvalForm.remarks"
              class="textarea-class"
              placeholder="请填写补充内容"
            ></el-input>
          </el-form-item>
        </div>
        <div v-show="appointDialog">
          <el-form-item label="审核结果" prop="auditResults">
            <el-radio-group
              v-model="approvalForm.auditResults"
              @change="changeRadio"
            >
              <el-radio label="assign">指派人员</el-radio>
              <el-radio label="cancel">取消保单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="指派人员"
            v-show="appointTag"
            prop="assignUserCode"
          >
            <My-Select
              class="reject-class"
              v-model="approvalForm.assignUserCode"
              :objSelect="approvalForm.assignUserCode"
              :options="assignManList"
              :placeholder="placeholderAssignMan"
              :optionBind="optionAssignMan"
              @changeSelct="changeAssignMan"
            ></My-Select>
          </el-form-item>
          <el-form-item label="审核备注" v-show="appointTag">
            <el-input
              type="textarea"
              maxlength="200"
              rows="5"
              show-word-limit
              v-model="approvalForm.remarks"
              class="textarea-class"
              placeholder="请填写审核备注"
            ></el-input>
          </el-form-item>
        </div>
        <div v-show="cancelDialog">
          <el-form-item label="取消原因" prop="reason">
            <el-input
              type="textarea"
              maxlength="200"
              rows="5"
              show-word-limit
              v-model="approvalForm.reason"
              class="textarea-class"
              placeholder="请填写取消原因"
            ></el-input>
          </el-form-item>
        </div>
        <div v-show="closeDialog">
          <el-form-item label="关闭原因" prop="reason">
            <el-input
              type="textarea"
              maxlength="200"
              rows="5"
              show-word-limit
              v-model="approvalForm.reason"
              class="textarea-cancel-class"
              placeholder="请填写关闭原因"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" style="text-align:center">
        <el-button type="primary" @click="submitForm('approvalForm')"
          >确定</el-button
        >
        <el-button @click="resetForm('approvalForm')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import asyncApi from "../../api/asyncApi";
import common from "../../../public/static/common.js";

export default {
  name: "extendedPolicyManagement",
  data() {
    let recme = this;
    return {
      fileList: [],
      stateName: "",
      orderCode: "",
      appTag: "",
      title: "",
      isIndeterminate: true,
      checkAll: true,

      closeDialog: false,
      cancelDialog: false,
      approvalDialog: false,
      appointDialog: false,
      approvalStateDialog: false,
      extendedPolicyDetailDialog: false,
      cities: [
        // {
        //   label: "all",
        //   value: '全部'
        // },
        {
          label: 'PAY',
          value: '待支付'
        },
        {
          label: 'SUBMIT',
          value: '待提交'
        },
        {
          label: 'RESUBMIT',
          value: '待修改'
        },
        {
          label: 'CHECK',
          value: '待审核'
        },
        {
          label: 'FILL',
          value: '待补充'
        },
        {
          label: 'EFFECT',
          value: '已生效'
        },
        {
          label: 'CLOSE',
          value: '已失效'
        },
        {
          label: 'CANCEL',
          value: '已取消'
        }
      ],
      optionReason: {
        label: "enumValue",
        value: "enumValue",
      },
      optionAssignMan: {
        label: "tertiaryNameAndPhone",
        value: "agentSalesCode",
      },
      optionBindsalesChannels:{
        label: 'name',
        value: 'code'
      },//销售渠道
      optionWf:{
        label: 'agentBranName',
        value: 'agentBranCode'
      },
      optionBindEw: {
        label: "prodName",
        value: "prodCode",
      },
      optionBindBrand: {
        label: "dicBrandName",
        value: "dicBrandCode",
      },
      optionBindCategory: {
        label: "dicTypeName",
        value: "dicTypeCode",
      },
      optionSalesLeve:{
        label: "agentSalesPhone",
        value: "agentSalesName",
        code: 'agentSalesCode'
      },
      placeholderAssignMan: "请选择指派人员",
      ewPlaceholder: "请选择延保产品",
      wfPlaceholder: '请选择机构',
      salesChannelsPlaceholder: '请选择销售渠道',
      placeholder: "请选择查询状态",
      brandPlaceholder: "请选择品牌",
      categoryPlaceholder: "请选择品类",
      salesLevelPlaceholder: "请输入销售人员姓名/电话",
      extendedForm: {
        name: "",
        // prodName: "",
        prodCode: "",
        area: [],
        areaProvince: "",
        areaCity: "",
        areaCounty: "",
        createTimeStart: "",
        createTimeEnd: "",
        dicBrandCode: "",
        dicTypeCode: "",
        state: "",
        stateArray: [],
        agent: [],
        agentCode: "",
        agentBranCode: "",
        fillTimeStart: "",
        fillTimeEnd: "",
        effectiveDateStart: "",
        effectiveDateEnd: "",
        salesLevelCode: "", //TODO
        agentSalesCode: "",
        passTimeStart: "",
        passTimeEnd: "",
        sysCode: "PC"
      },
      fileDownName: '导入生效延保单模板.xlsx',
      // 列表配置
      configurationData: [
        // {
        //   title: '序号',
        //   scopedSlots: { customRender: 'num' }
        //   // property: 'num'
        // },
        {
          title: "延保单单号",
          propertys: "extensionPolicyId",
          width: "",
          link: this.linkToinfo,
        },
        {
          title: "延保单状态",
          propertys: "stateName",
          width: "100px",
        },
        {
          title: "延保产品名称",
          propertys: "prodName",
          width: "",
        },
        {
          title: "客户姓名/电话",
          propertys: "customerInfo",
          width: "",
        },
        {
          title: "收货地址/房屋地址",
          propertys: "addressInfo",
          width: "",
        },
        {
          title: "三级销售人员",
          propertys: "tertiaryInfo",
          width: "",
        },
        {
          title: "品类",
          propertys: "dicTypeName",
          width: "100px",
        },
        {
          title: "延保销售价格/元",
          propertys: "price",
          width: "100px",
          format: this.formatPrice,
        },
        {
          title: "机构名称",
          propertys: "agentBranName",
          width: "",
        },
        {
          title: "保障期限",
          propertys: "expiryDateStr",
          width: "80px",
        },
        {
          title: "建单时间",
          propertys: "createTime",
          width: "",
        },
      ],
      // 是否有操作按钮 宽度
      operation: {
        show: true,
        width: "",
      },
      // 是否有多选
      showSwitch: true,
      menuList: [],
      getTableParam: {
        url: "/extwarapi/api/extensionPolicy/page",
        param: "",
      },
      queryProps: {
        value: "name",
        label: "name",
        children: "cities",
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node, resolve) {
          const { level } = node;
          let nodes = [];

          if (level == 0) {
            await recme.getProvince();
            nodes = recme.provinceList;
          }
          if (level == 1) {
            await recme.getCity(node.data.code);
            nodes = recme.cityList;
          }
          if (level == 2) {
            await recme.getDistricts(node.data.code);
            nodes = recme.districtList;
            //console.log(nodes);

            nodes.forEach((element) => {
              element.leaf = true;
            });
          }
          setTimeout(() => {
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
            //console.log('nodes',nodes)
          }, 200);
        },
      },
      queryOrgan: {
        value: "code",
        label: "name",
        children: "organ",
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node, resolve) {
          const { level } = node;
          let organNodes = [];

          if (level == 0) {
            await recme.getAgentEnum();
            organNodes = recme.agentList;
            //console.log('organNodes',organNodes,'node',node,'res',resolve)
          }

          if (level == 1) {
            await recme.getAgentBranchEnum(node.data.code);
            // await recme.getEwProduct(node.data.code)
            organNodes = recme.agentBranchList;
            organNodes.forEach((element) => {
              element.leaf = true;
            });
          }
          setTimeout(() => {
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(organNodes);
            //console.log('organNodes',organNodes)
          }, 200);
        },
      },
      salesChannelsProductList: [
        {code:'1',name: '线上商城'},
        {code: '0',name: '线下商店'}
      ],//销售渠道
      getDetailShow: '0',
      ewProductList: [],
      prodBrandList: [],
      categoryList: [],
      salesLevelList: [],
      formList: [],
      detailList: [],
      approvalForm: {
        assignUserCode: "",
        auditResults: "",
        extensionPolicyId: "",
        reason: "",
        remarks: "",
        userCode: "",
      },
      noPassInformationTag: false, //审核不通过
      appointTag: false, //指派人员
      addInformationTag: false, //补充资料
      rules: {
        auditResults: [
          { required: true, message: "请选择审核结果", trigger: "blur" },
        ],
        assignUserCode: [
          { required: true, message: "请选择指派人员", trigger: "blur" },
        ],
        reason: [
          {
            required: true,
            message: "请选择驳回原因/输入取消/关闭原因",
            trigger: "blur",
          },
        ],
        remarks: [
          { required: true, message: "请输入审核备注", trigger: "blur" },
        ],
      },
      assignManList: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      reasonList: [],
      opinionObj: "",
      agentList: [],
      agentBranchList: [],
      wfAgentBranchList: [],//文峰机构
      ageForm: {
        // wfCode: '',
        // wfName: ''
        agentBranCode:'',
        agentBranName: ''
      },
      // wfCode: '',
      approvalInfoForm: {
        createTime: "",
        applyUserName: "",
        reason: "",
        remarks: "",
      },
      approvalInfoTag: false,
      multipleSelection: [],
      childItem: [],
      rowDemo: {},
      orderPrefix: '',
      orderPrefixList: {},
      // 根据权限判断审核，取消，指派按钮
      buttonKey:{
        checkButton:false,
        appointButton:false,
        closeButton:false,
        operationButton:false
      },
        submitButton:false,
        List: []
    };
  },
  computed: {
    // 这里定义上传文件时携带的参数，即表单数据
    upData: function() {
      // this.ageForm 机构参数
      let param = {
        agentBranCode: this.ageForm.agentBranCode,
        userCode: common.getCurrUser().userCode
      }
      return param
    }
  },
  methods: {
    // 获取用户权限
    getMenuList() {
      //console.log('用户',common.getCurrUser())
      let usercode = common.getCurrUser().userCode;
      let url = "/extwarapi/api/rights/getMenu";
      let param = { code: usercode };
      this.axios
        .post(url, param)
        .then((resp) => {
          //console.log("menulist", resp.data);
          if(resp.data.code=='0000'){
            this.menuList = resp.data.result.menuList;
            //console.log("menulist11-", resp.data.result);
            // 判断操作列表
            for(let j =0;j<this.menuList.length;j++){
              let index = this.menuList[j]
              if(index.index=='3'&&index.subItem.length==1){
                //console.log('zhiyouyitioa')
                // this.buttonKey.operationButton = true
                this.operation.show = false
              }
            }
            // 判断操作按钮
            for(let i =0;i<resp.data.result.buttonList.length;i++){
              let item = resp.data.result.buttonList[i]
              if(item.index=='3-0-0'&&item.state=='C'){
                // 审核显示
                this.buttonKey.checkButton=true
              }else if(item.index=='3-0-1'&&item.state=='C'){
                // 关闭显示
                this.buttonKey.closeButton=true
              }else if(item.index=='3-0-2'&&item.state=='C'){
                // 指派显示
                this.buttonKey.checkButton=true
              }else if(item.index=='3-0-3'&&item.state=='C'){
                this.submitButton = true
              }
            }
          }
        })
        .catch((resp) => {
          //console.log("error", resp);
        });
    },
    displayCls: function(prop) {
      let isshow = false;
      if (prop.propertyInfos) {
        for (let i = 0; i < prop.propertyInfos.length; i++) {
          let item = prop.propertyInfos[i];
          if (item.phidclass && item.phidclass.length > 0) {
          } else {
            isshow = true;
            break;
          }
        }
      }
      let cls = "";
      if (!isshow) {
        cls = "ss-hid";
      }
      return cls;
    },
    changeState(value) {
      this.extendedForm.stateArray.push(value)
      // console.log('value',value,this.extendedForm)
      this.query();
    },
    handleCheckAllChange(val){
      this.extendedForm.stateArray= []
      this.isIndeterminate = false
    },
    changeStateArray(value){
      // console.log('value',value)
      let checkCount = value.length
      this.checkAll = false
      if (checkCount >0){
        this.isIndeterminate = false
      }
      
      // console.log('value11',value,'2--',this.extendedForm)
    },
    
    getList(item, index) {
      // console.log('getList',item.propertyInfos,'index',index)
      // console.log('item.propertyInfos[index]',item.propertyInfos[index])
      if(item.propertyInfos[index]){
        // if(item.propertyInfos[index].propertyCode&&item.propertyInfos[index].propertyCode=='100107'){
        //   if(window.sessionStorage.getItem('orderPrefix')=='线上商城'){
        //     console.log('111',window.sessionStorage.getItem('orderPrefix'))
        //     item.propertyInfos[index].propertyValue = 'E'
        //     item.propertyInfos[index].propertyValueName = 'E'
        //   } else if(window.sessionStorage.getItem('orderPrefix')=='线下商店'){
        //     item.propertyInfos[index].propertyValue = 'LS'
        //     item.propertyInfos[index].propertyValueName = 'LS'
        //   }else {
        //     console.log('22222',item.propertyInfos[index])
        //   }
        //   console.log('222',item.propertyInfos[index])
        //   return item.propertyInfos[index]
        // }
        // else{
          return item.propertyInfos[index];
        // }
      }
      
      
    },
    
    // 获取子组件改变的值
    childFormValue(val) {
      this.childItem = val;
      // this.orderPrefix = val.propertyValueName
      // if(val.propertyCode&&val.propertyCode=='100108'){
      //   console.log('dijici',val,'---',this.rowDemo)
      //   if(val.propertyValueName!=window.sessionStorage.getItem('orderPrefix')){
      //     this.getDetail(this.rowDemo)
      //   }
        
      //   window.sessionStorage.setItem('orderPrefix',val.propertyValueName)
      // }
      
      console.log("zizujina", val,window.sessionStorage.getItem('orderPrefix'));
    },
    formatPrice(row) {
      if(row.price == 0){
        return "0"
      }else{
        return common.formatPrice(row.price);
      }
      
    },
    changeEwSelct(value) {
      // this.extendedForm.prodName = value;
      this.extendedForm.prodCode = value;
    },
    changeWfSelct(value){
      console.log('value',value)
      this.ageForm.agentBranName = value
      this.wfAgentBranchList.includes
      for(let i=0;i<this.wfAgentBranchList.length;i++){
        if(this.wfAgentBranchList[i].agentBranName ==value){
          console.log('va====',this.wfAgentBranchList[i])
          this.ageForm.agentBranCode = this.wfAgentBranchList[i].agentBranCode
        }
      }
      // this.extendedForm.wfAgentBranch = value
    },
    getBlur(val){
      console.log('val----2',val,this.titem)
      // this.getValue()
    },
    changesalesChannelsSelct(value){
      // 销售渠道
      console.log('小猴',value)
      this.extendedForm.salesChannels = value
    },
    changeBrandSelct(value) {
      this.extendedForm.dicBrandCode = value;
      //console.log('pimlei',value)
    },
    changeSalesleveSelct(value){
      //console.log('value11---',value)
      let index = value.split('/')
      // let userName = index[0]
      // let userphone = index[1]
      let indexdata = ''
      for(let i=0;i<this.salesLevelList.length;i++){
        if(this.salesLevelList[i].agentSalesName == index[0] &&this.salesLevelList[i].agentSalesPhone == index[1]){
          indexdata = this.salesLevelList[i].agentSalesCode
          //console.log(this.salesLevelList[i].agentSalesCode,'1111')
        }
      }
      this.extendedForm.agentSalesCode = indexdata
      // let index = value.split('/')
      // //console.log('value22--',index)
      
      // this.extendedForm.agentSalesCode = value
    },
    changeCategorySelct(value) {
      this.extendedForm.dicTypeCode = value;
    },
    changeAssignMan(value) {
      this.approvalForm.assignUserCode = value;
    },
    changeReason(value) {
      this.approvalForm.reason = value;
    },
    query() {
      let param = Object.assign({}, this.extendedForm);
      if (param.area[0]) {
        param.areaProvince = param.area[0];
      }
      if (param.area[1]) {
        param.areaCity = param.area[1];
      }
      if (param.area[2]) {
        param.areaCounty = param.area[2];
      }
      if (param.agent[0]) {
        param.agentCode = param.agent[0];
      }
      if (param.agent[1]) {
        param.agentBranCode = param.agent[1];
      }
      // for (let i = 0;i <param.stateArray.length;i++){
      //   if(param.stateArray[i]==="all") {
      //     param.stateArray = []
      //   }
      // }
      // console.log('param',param)
      this.getTableParam.param = param;
      this.$refs.myTable.query(1);
    },
    //获取延保产品字典
    async getEwProduct() {
      let url = "/extwarapi/api/extension/getProdEnum";
      let code = {
        "code": ''
      }
      if(common.getCurrUserRoleList()[0].roleCode!='admin'){
        code.code = common.getCurrUser().agentCode
      }
      let data = await asyncApi.post(url, code);
      if (data.code == "0000") {
        this.ewProductList = data.result;
        //console.log('ewprodList',this.ewProductList)
      }
    },
    //获取品牌产品字典
    async getProdBrand() {
      // let url = "/extwarapi/api/dicProdBrand/getBrandEnum";
      let url = "/extwarapi/api/dicProdBrand/getBrandEnumByAgentCode"
      let code = {
        "agentCode": '',
        "userRole": ''
      }
      if(common.getCurrUserRoleList()[0].roleCode!='admin'){
        code.userRole = common.getCurrUserRoleList()[0].roleCode
        code.agentCode = common.getCurrUser().agentCode
      }
      let data = await asyncApi.post(url, code);
      if (data.code == "0000") {
        this.prodBrandList = data.result;
      }
    },
    // 获取销售人员
    async getSalesInfoLikeNameOrPhone(){
      let url = "/extwarapi/api/agentSalesMan/getSalesInfoLikeNameOrPhone"
      let agentCode = ''
      let userRole = ''
      if(common.getCurrUserRoleList()[0].roleCode!='admin'){
        userRole = common.getCurrUserRoleList()[0].roleCode
        agentCode = common.getCurrUser().agentCode
      }
      this.axios.post(url, { "agentCode":agentCode,"userRole":userRole }).then((resp) => {
        if (resp.data.code == "0000") {
          this.salesLevelList = resp.data.result
        }
        //console.log('getSale',resp.data.result)
      })
      .catch((resp) => {
        //console.log("error", resp);
      });
    },
    //获取品类产品字典
    async getCategory() {
      // let url = "/extwarapi/api/dicProdType/getTypeEnum";
      let url = "/extwarapi/api/dicProdType/getTypeEnumByAgentCode"
      let code = {
        "agentCode": '',
        "userRole": ''
      }
      if(common.getCurrUserRoleList()[0].roleCode!='admin'){
        code.userRole = common.getCurrUserRoleList()[0].roleCode
        code.agentCode = common.getCurrUser().agentCode
      }
      let data = await asyncApi.post(url, code);
      if (data.code == "0000") {
        this.categoryList = data.result;
      }
    },
    //获取驳回原因字典
    async getRejectedList() {
      let url = "/extwarapi/api/tools/getEnumsByCode";
      let data = await asyncApi.post(url, { code: "rejected" });
      if (data.code == "0000") {
        this.reasonList = data.result;
      }
    },
    // table
    getMultipleSelection(data) {
      this.multipleSelection = []
      for(let i in data){
        this.multipleSelection.push(data[i].extensionPolicyId)
      }
      //console.log('选中的值为:'+this.multipleSelection.join(),'data',data)
      // //console.log("table选中", this.multipleSelection);
    },
    downEx(){
      let url="/extwarapi/api/file/localDownLoad?savePath="+'/opt/extwarmng/javaapp/attach/20210713/sxybdmb.xlsx'
      // let url="/extwarapi/api/file/localDownLoad?savePath="+'/data/projects/extwarmng/javaapp/attach/20210713/imp/e7deca78-f376-40b8-861e-8ce7ae6543a8.xlsx'
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: "blob"
      }
      this.axios.get(url, config).then((resp) => {
          console.log('resp',resp)
          // let fileName=decodeURIComponent(resp.headers["content-disposition"]).split('=')[1];
          let fileName = '导入生效延保单模板.xlsx'
          let blob = new Blob([resp.data], { type: ".xlsx" });
          if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob,fileName);
          } else {
            let a = document.createElement("a");
            a.download = fileName;
            a.href = window.URL.createObjectURL(blob);
            a.click();
            window.URL.revokeObjectURL(a.href)
          }
        }).catch((resp) => {
          console.log('error', resp);
        })
    },
    httpRequest(param){
      let fileObj = param.file
      let fd = new FormData()
      fd.append('file',fileObj)
      fd.append('userCode',common.getCurrUser().userCode)
      fd.append('agentBranCode',this.ageForm.agentBranCode)
      let url = '/extwarapi/api/extensionPolicy/importExtensionOrder'
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: "blob"
      }
      this.axios.post(url,fd,config).then(res=>{
        console.log(res,'ressssss')
        let fileName=decodeURIComponent(res.headers["content-disposition"]).split('=')[1];
        if(fileName){
          this.$message({
            message: '导入失败',
            type: 'error'
          })
          // let fileName=decodeURIComponent(res.headers["content-disposition"]).split('=')[1];
          console.log('fileName',fileName)
          var blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) 
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob,fileName);
          } else {
            let a = document.createElement("a");
            a.download = fileName;
            a.href = window.URL.createObjectURL(blob);
            a.click();
            window.URL.revokeObjectURL(a.href)
          }
        }else {
          this.$message({
            message: '导入成功',
            type: 'success'
          })
        }
        this.$refs.upload.clearFiles()
      })
    },
    // 导入
    submitUpload() {
      console.log('daoru',this.upData)
      if(this.upData.agentBranCode){
        this.$refs.upload.submit();
      }else {
        this.$message({
          message: '请选择机构',
          type: 'warning'
        })
      }
    },
    beforeRemove(file, fileList) {
      console.log('file',file,'ile',fileList)
      // if (this.Qualified == "") {
      //   return this.$confirm(`确定移除 ${file.name}？`);
      // } else if (this.Qualified == "1") {
      //   return true;
      // }
    },
    handleSuccess(response, file, fileList){
      console.log('success',response, file, fileList)
      // if(response=='success'){
      //   this.$message({
      //     message: '导入成功',
      //     type: 'success'
      //   })
      // }else {
      //   this.$message({
      //     message: '导入失败',
      //     type: 'error'
      //   })
      // }
    },
    handleError(res){
      console.log('失败',res)
    },
    handleProgress(event, file, fileList){
      // console.log('progress',event, file, fileList)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    // 导出 
    exportExt() {
      if(this.multipleSelection.length === 0){
        this.$message({
          message: '请至少勾选一项，再进行操作',
          type: 'warning'
        })
      }else{
        //console.log("选中导出", this.multipleSelection);
        // this.$refs.myTable.clearSelection()
        // this.multipleSelection= []
        // this.$refs["myTable"].query(1);
        this.extendedForm.orderCodeList=[]
        for(var i=0;i<this.multipleSelection.length;i++){
          this.extendedForm.orderCodeList.push(this.multipleSelection[i])
          //console.log('orderCodeList',this.extendedForm.orderCodeList)
        }
        // if(common.getCurrUser().agentCode){
        //   this.extendedForm
        // }
        let url="/extwarapi/api/extensionPolicy/pageExport";
        let param=Object.assign({},this.extendedForm);
            param.pageNum=1;
            param.pageSize=9999;
        this.axios.post(url, param,{responseType: "blob"}).then((resp) => {
          console.log('resp',resp)
          let fileName=decodeURIComponent(resp.headers["content-disposition"]).split('=')[1];
          let blob = new Blob([resp.data], { type: ".xlsx" });
          if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob,fileName);
              //console.log('success')
          } else {
            //console.log('success-2')
            let a = document.createElement("a");
            a.download = fileName;
            a.href = window.URL.createObjectURL(blob);
            a.click();
            //console.log('success-3')
            // 清除选中状态
            // if(this.extendedForm.orderCodeList){
              setTimeout(()=>{
                this.$refs.myTable.clear()
                this.extendedForm.orderCodeList = []
              },1500)
              
            // }
            
            //释放内存
            
              window.URL.revokeObjectURL(a.href)
          }
          // this.extendedForm.orderCodeList=[]
          
        }).catch((resp) => {
          //console.log('error', resp);
        })
      }
      
      
    },
    // TODO
    exportExtAll() {
      let url="/extwarapi/api/extensionPolicy/pageExport";
      let param=Object.assign({},this.extendedForm);
          param.pageNum=1;
          param.pageSize=1000000;
      if(common.getCurrUserRoleList()[0].roleCode!='admin'){
        param.agentCode = common.getCurrUser().agentCode
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.axios.post(url, param,{responseType: "blob"}).then((resp) => {
        loading.close();
        let fileName=decodeURIComponent(resp.headers["content-disposition"]).split('=')[1];
        let blob = new Blob([resp.data], { type: ".xlsx" });
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob,fileName);
        } else {
            let a = document.createElement("a");
            a.download = fileName;
            a.href = window.URL.createObjectURL(blob);
            a.click();
            //释放内存
              window.URL.revokeObjectURL(a.href)
        }
      }).catch((resp) => {
        loading.close();
        //console.log('error', resp);
      })
      //console.log("全部数据导出");
    },
    linkToinfo(row) {
      // console.log("row-1",this.formList,this.opinionObj);
      this.rowDemo = row
      this.formList = []
      this.opinionObj = ""
      this.orderCode = row.extensionPolicyId;
      this.stateName = row.stateName;
      this.$nextTick(() => {
        this.getDetail(row);
        this.extendedPolicyDetailDialog = true;
        window.sessionStorage.setItem('orderPrefix','')
      });
    },
    async getDetail(row) {
      console.log("row-2", row, "currentUser", common.getCurrUser());
      let me = this;
      let url = "/extwarapi/api/extensionPolicy/formDetail";
      let formCode = "100";
      if (row.formCode) {
        formCode = row.formCode;
      }
      this.getDetailShow = '1'
      let param = {
        // agentSalesCode: 
        orderCode: row.extensionPolicyId,
        currentUser: common.getCurrUser().userCode,
        formCode: formCode,
        nodeCode: "500",
      };
      // 1、判断用户是否有修改，审核权限（根据权限在详情中判断显隐）
      // 2、根据用户下权限调用不同的nodecode
      await asyncApi
        .post(url, param)
        .then((resp) => {
          if (resp.code == "0000") {
            me.opinionObj = "";
            if (resp.result.opinion != null) {
              if (
                resp.result.opinion.reason &&
                resp.result.opinion.reason != ""
              ) {
                resp.result.opinion.auditResultsName =
                  resp.result.opinion.reason;
              }
              me.opinionObj = resp.result.opinion;
            }else {
              me.opinionObj = ''
            }
            me.formList = resp.result.propertyInfos;
            me.detailList = resp.result;
            //console.log("formList", me.formList);
            //有些数据需要特殊处理，比如条码，要根据实际产品显示或隐藏
            //TODO
            me.buildSpecialProperty(this.formList);
          }
        })
        .catch((resp) => {
          console.log("error", resp);
        });
    },
    buildSpecialProperty: function(propertyInfos) {
      //条码 //依赖于产品的data[i].barcode;
      let prodProp = this.findPropByAlias(propertyInfos, "prod");
      if (prodProp && prodProp.propertyValue) {
        this.buildBarcodeProperty(propertyInfos, prodProp);
      }
    },
    buildBarcodeProperty: function(propertyInfos, prodProp) {
      let prodData = prodProp.data;
      let bar1Prop = this.findPropByAlias(propertyInfos, "barCode1");
      let bar2Prop = this.findPropByAlias(propertyInfos, "barCode2");
      let prodBarVal = "";
      let prodVal = prodProp.propertyValue;
      if (prodData) {
        for (let i = 0; i < prodData.length; i++) {
          let pdata = prodData[i];
          if ((pdata.code = prodVal)) {
            prodBarVal = pdata.barCode;
            break;
          }
        }
      }

      if (prodBarVal == "0" || prodBarVal == "") {
        bar1Prop.phidclass = "ss-hid";
        bar2Prop.phidclass = "ss-hid";
      } else if (prodBarVal == "1" || prodBarVal == "3") {
        bar1Prop.phidclass = "";
        bar2Prop.phidclass = "ss-hid";
      } else if (prodBarVal == "2") {
        bar1Prop.phidclass = "";
        bar2Prop.phidclass = "";
      }
    },
    findPropByAlias: function(propertyInfos, alias) {
      if (propertyInfos) {
        for (let i = 0; i < propertyInfos.length; i++) {
          let props = propertyInfos[i].propertyInfos;
          if (props) {
            for (let j = 0; j < props.length; j++) {
              let prop = props[j];
              if (prop.alias && prop.alias == alias) {
                return prop;
              }
            }
          }
        }
      }
      return null;
    },
    async getProvince() {
      let url = "/extwarapi/api/tools/getProvince";
      let data = await asyncApi.post(url, {});
      if (data.code == "0000") {
        this.provinceList = common.conversionList(
          data.result,
          "provinceCode",
          "code",
          "provinceName",
          "name"
        );
      }
    },
    async getCity(code) {
      let url = "/extwarapi/api/tools/getCity";
      let data = await asyncApi.post(url, { code: code });
      if (data.code == "0000") {
        this.cityList = common.conversionList(
          data.result,
          "cityCode",
          "code",
          "cityName",
          "name"
        );
      }
    },
    async getDistricts(code) {
      let url = "/extwarapi/api/tools/getDistricts";
      let data = await asyncApi.post(url, { code: code });
      if (data.code == "0000") {
        this.districtList = common.conversionList(
          data.result,
          "districtCode",
          "code",
          "districtName",
          "name"
        );
      }
    },
    // async getAgentEnum() {
    //   let url = "/extwarapi/api/agent/getAgentEnum";
    //   let data = await asyncApi.post(url, {});
    //   if (data.code == "0000") {
    //     this.agentList = common.conversionList(
    //       data.result,
    //       "agentCode",
    //       "code",
    //       "agentName",
    //       "name"
    //     );
    //   }
    // },
    // 机构
    async getAgentBranchEnum(code) {
      let url = "/extwarapi/api/agent/getAgentBranchEnum";
      let data = await asyncApi.post(url, { code: code });
      if (data.code == "0000") {
        this.agentBranchList = common.conversionList(
          data.result,
          "agentBranCode",
          "code",
          "agentBranName",
          "name"
        );
      }
    },
    // 获取文峰的机构
    getWfAgent() {
      let url = "/extwarapi/api/agent/getAgentBranchEnum";
      let param = {code:"AGENT202008220000"}
      this.axios.post(url, param).then((resp) => {
        console.log('res',resp)
        if (resp.data.code == '0000') {
          this.wfAgentBranchList = resp.data.result
        //   this.wfAgentBranchList = common.conversionList(
        //   resp.data.result,
        //   "agentBranCode",
        //   "code",
        //   "agentBranName",
        //   "name"
        // );
        }
      })
    },
    bindLabel(item){
      let tLabel = this.optionWf.label
      this.ageForm.wfName = item[tLabel]
      return item[tLabel];
    },
    bindValue(item){
      let tValue = this.optionWf.value
      this.ageForm.wfCode = item[tValue]
      return item[tValue];
    },
    // 承销商
    async getAgentEnum(){
      //console.log('user',common.getCurrUserRoleList())
      let url = "/extwarapi/api/agent/getAgentEnumByUserRole"
      let sname = common.getCurrUserRoleList()[0].roleCode
      let scode = common.getCurrUser().agentCode
      let data = await asyncApi.post(url,{userRole:sname,agentCode:scode })
      if (data.code == "0000") {
        this.agentList = common.conversionList(
          data.result,
          "agentCode",
          "code",
          "agentName",
          "name"
        );
      }
    },
    //  TODO:延保单详情修改单号，机械购买时间
    submit() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let url = "/extwarapi/api/extensionPolicy/updateForm";
      //console.log("submit", this.detailList);
      // let strFormDetail = JSON.stringify(this.detailList);
      // let subFormDetail = JSON.parse(strFormDetail);
      // let layers = subFormDetail.propertyInfos;
      // let tprops = [];
      // layers.forEach((element) => {
      //   tprops.push(element.propertyInfos);
      // });
      // let props = [];
      // props = tprops.reduce((pre, item) => {
      //   return pre.concat(item);
      // });
      // //console.log("props", props, "formList", this.formList);
      let me = this;
      let param = {
        // dependent: me.detailList.dependent,
        createUser: common.getCurrUser().userCode,
        propertyInfos: this.formList,
        orderCode: me.orderCode,
      };
      //console.log("param", param, common.getCurrUser());
      // 判断商品销售单号和机械销售单号的格式
      
      // let infos = this.detailList.propertyInfos;
      // let codeValue1 = infos[0].propertyInfos[6].propertyValueName;
      // let codeValue2 = infos[3].propertyInfos[9].propertyValueName;
      // let pattern = /^LS\d{6}$/;
      // let codetitle = "";
      // if (pattern.test(codeValue1) && pattern.test(codeValue2)) {
        me.axios
          .post(url, param)
          .then((resp) => {
            if (resp.data.code == "0000") {
              loading.close()
              this.$alert("操作成功!", "提示信息", {
                confirmButtonText: "确定",
                callback: (action) => {
                  me.approvalStateDialog = false;
                  me.extendedPolicyDetailDialog = false
                  me.$refs["myTable"].query(1);
                },
              });
            } else {
              this.$alert(resp.data.msg, "提示信息", {
                confirmButtonText: "确定",
                callback: (action) => {
                  me.extendedPolicyDetailDialog = false
                },
              });
              return;
            }
          })
          .catch((resp) => {
            //console.log("error", resp);
          });
      // } 
      // else if (!pattern.test(codeValue1) && !pattern.test(codeValue2)) {
      //   codetitle = "两个销售单号格式都不正确";
      //   this.$alert("错误提示!", codetitle, {
      //     confirmButtonText: "确定",
      //     callback: (action) => {
      //       me.approvalStateDialog = false;
      //       me.$refs["myTable"].query(1);
      //     },
      //   });
      // } else if (!pattern.test(codeValue1)) {
      //   codetitle = "机器销售单号格式不正确";
      //   this.$alert(codetitle, "错误提示!", {
      //     confirmButtonText: "确定",
      //     callback: (action) => {
      //       me.approvalStateDialog = false;
      //       me.$refs["myTable"].query(1);
      //     },
      //   });
      // } else if (!pattern.test(codeValue2)) {
      //   codetitle = "延保销售单号格式不正确";
      //   this.$alert("错误提示!", codetitle, {
      //     confirmButtonText: "确定",
      //     callback: (action) => {
      //       me.approvalStateDialog = false;
      //       me.$refs["myTable"].query(1);
      //     },
      //   });
      // }
    },
    // 待审核延保单详情的审核
    extendedEditor1(code) {
      this.approvalInfoForm =  {}
      this.approvalStateDialog = true;
      //console.log("extend", this.formList, "---1---", code);
      this.title = "审核";
      this.appTag = "approval";
      this.approvalForm.auditResults = "pass";
      this.approvalDialog = true; //审核
      this.appointDialog = false; //指派
      this.cancelDialog = false; //取消
      this.noPassInformationTag = false;
      this.closeDialog = false;
      this.addInformationTag = false;
      this.getRejectedList();
      this.getCheckOpinion();
      // this.approvalForm.extensionPolicyId = this.formList[3].propertyInfos[0].propertyValueName;
      let orderList = this.detailList.baseInfo.propertyInfos
      for(let i =0;i<orderList.length;i++){
        if(orderList[i].propertyCode == 'orderCode'){
          this.approvalForm.extensionPolicyId = orderList[i].propertyValue
        }
      }
      // console.log('valueName',this.detailList)
    },
    extendedEditor(tag, row) {
      // console.log("row-3", row, "-tag", tag);
      // console.log('fom',this.approvalForm)
      // this.approvalForm = {}
      this.approvalStateDialog = true;
      if (row) {
        this.orderCode = row.extensionPolicyId;
        this.stateName = row.stateName;
      }

      if (tag == "approval") {
        console.log('approval')
        this.title = "审核";
        this.appTag = "approval";
        this.approvalForm.auditResults = "pass";
        this.approvalDialog = true; //审核
        this.appointDialog = false; //指派
        this.cancelDialog = false; //取消
        this.noPassInformationTag = false;
        this.closeDialog = false;
        this.addInformationTag = false;
        this.getRejectedList();
        this.getCheckOpinion();
      } else if (tag == "appoint") {
        this.title = "指派";
        this.appTag = "appoint";
        this.approvalForm.auditResults = "assign";
        this.appointDialog = true;
        this.appointTag = true;
        this.approvalDialog = false;
        this.cancelDialog = false;
        this.closeDialog = false;
        this.getAllAssignMan();
      } else if (tag == "close") {
        this.title = "关闭";
        this.appTag = "close";
        this.approvalInfoTag = false;
        this.closeDialog = true; //关闭
        this.approvalDialog = false; //审核
        this.appointDialog = false; //指派
        this.cancelDialog = false;
        // this.approvalForm.reason = ""
        // console.log('close')
      }
      this.approvalForm.extensionPolicyId = row.extensionPolicyId;
    },
    submitForm(formName) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // debugger;
      //console.log("formName", formName);
      let url = "/extwarapi/api/extensionPolicy/check";
      let param = Object.assign({}, this.approvalForm);
      let usercode = common.getCurrUser().userCode;
      param.userCode = usercode;
      if (this.appTag == "close") {
        param.auditResults = "close";
      }
      let validFields = [];
      if (this.appTag == "approval" && param.auditResults == "nopass") {
        validFields.push("reason");
        validFields.push("remarks");
        validFields.push("auditResults");
      }
      if (this.appTag == "approval" && param.auditResults == "add") {
        validFields.push("remarks");
        validFields.push("auditResults");
      }
      if (this.appTag == "approval" && param.auditResults == "cancel") {
        validFields.push("reason");
        validFields.push("auditResults");
      }
      if (this.appTag == "appoint" && param.auditResults == "assign") {
        validFields.push("assignUserCode");
        validFields.push("auditResults");
      }
      if (this.appTag == "appoint" && param.auditResults == "cancel") {
        validFields.push("reason");
        validFields.push("auditResults");
      }
      if (param.auditResults == "close") {
        validFields.push("reason");
      }
      let me = this;
      let allValid = true;
      this.$refs[formName].validateField(validFields, (valid) => {
        if (valid.length > 0) {
          allValid = false;
        }
      });

      if (allValid) {
        me.axios
          .post(url, param)
          .then((resp) => {
            if (resp.data.code == "0000") {
              loading.close()
              this.$alert("操作成功!", "提示信息", {
                confirmButtonText: "确定",
                callback: (action) => {
                  me.approvalStateDialog = false;
                  me.approvalForm.reason = ""
                  me.$refs["myTable"].query(1);
                  // 延保单详情 审核成功关闭两个
                  if (me.extendedPolicyDetailDialog == true) {
                    me.extendedPolicyDetailDialog = false;
                  }
                },
              });
            } else {
              
              this.$alert(resp.data.msg, "提示信息", {
                confirmButtonText: "确定",
                callback: (action) => {
                  loading.close()
                  this.approvalStateDialog = false;
                },
              });
              return;
            }
            loading.close()
          })
          .catch((resp) => {
            console.log("error", resp);
            this.$alert(resp, "提示信息", {
                confirmButtonText: "确定",
                callback: (action) => {
                  loading.close()
                  this.approvalStateDialog = false;
                },
              });
          });
      } else {
        //console.log("error submit!!", allValid);
        return false;
      }

    },
    resetForm(formName) {
      // this.approvalInfoForm= {}
      // this.approvalForm = {}
      this.approvalStateDialog = false;
      
      this.$refs[formName].resetFields();
    },
    changeRadio(value) {
      this.approvalForm.assignUserCode = "";
      this.approvalForm.reason = "";
      this.approvalForm.remarks = "";
      if (value == "pass") {
        //审核通过
        // console.log('pass')
        this.noPassInformationTag = false;
        this.appointDialog = false;
        this.closeDialog = false;
        this.cancelDialog = false;
        this.addInformationTag = false;
      } else if (value == "nopass") {
        //审核不通过
        // console.log('nnopass')
        this.noPassInformationTag = true;
        this.appointDialog = false;
        this.closeDialog = false;
        this.cancelDialog = false;
        this.addInformationTag = false;
      } else if (value == "add") {
        //补充资料
        // console.log('add')
        this.addInformationTag = true;
        this.noPassInformationTag = false;
        this.appointDialog = false;
        this.closeDialog = false;
        this.cancelDialog = false;
      } else if (value == "cancel") {
        //取消保单
        // console.log('cancel')
        if (this.appTag == "approval") {
          //审核
          this.cancelDialog = true;
          this.approvalDialog = true;
          this.noPassInformationTag = false;
          this.closeDialog = false;
          this.appointDialog = false;
          this.addInformationTag = false;
        } else if (this.appTag == "appoint") {
          this.appointDialog = true;
          this.cancelDialog = true;
          this.approvalDialog = false;
          this.closeDialog = false;
          this.appointTag = false;
          this.noPassInformationTag = false;
          this.addInformationTag = false;
        }
      } else if (value == "assign") {
        //指派人员
        this.appointDialog = true;
        this.appointTag = true;
        this.approvalDialog = false;
        this.cancelDialog = false;
        this.closeDialog = false;
      }
    },
    //获取指派人员
    getAllAssignMan() {
      let url = "/extwarapi/api/extensionPolicy/getAllAssignMan";
      let param = { code: this.orderCode };
      this.axios
        .post(url, param)
        .then((resp) => {
          if (resp.data.code == "0000") {
            this.assignManList = resp.data.result;
          }
        })
        .catch((resp) => {
          //console.log("error", resp);
        });
    },
    //获取上次审核信息
    async getCheckOpinion() {
      this.approvalInfoTag = false
      this.approvalInfoForm =  {}
      let url = "/extwarapi/api/extensionPolicy/getNewestExtensionCheckOpinion";
      let data = await asyncApi.post(url, { code: this.orderCode });
      if (data.code == "0000") {
        if (data.result.id) {
          this.approvalInfoTag = true;
          this.approvalInfoForm = data.result;
        }
      }
    },
    
    getSalesChannels(){
      let url = '/extwarapi/api/product/select'
      let that = this
      this.axios.post(url,'').then((resp)=>{
        console.log(resp)
        if (resp.data.code == '0000') {
          that.List = resp.data.result
        }
      })
    },
    getSales(val){
      console.log('val',val,'titem',this.titem,'this11',this.List)
      if(this.List){
        for(let i =0;i<this.List.length;i++){
          if(val == this.List[i].enumName){
            console.log('this',this.List[i])
            this.titem.propertyValue = this.List[i].enumKey
            this.titem.propertyValueName = this.List[i].enumValue
          }
        }
      }
      
    }
  },
  // watch: {
  //   orderPrefix(newVal, oldVal){
  //     if(newVal!=oldVal){
  //       console.log('extttt',newVal)
  //     }
  //   }
  // },
  mounted() {
    this.getMenuList();
    this.getEwProduct();
    this.getProdBrand();
    this.getCategory();
    this.getProvince();
    this.getWfAgent()
    // this.getAgentEnum();
    this.getSalesInfoLikeNameOrPhone();
    // this.getAgentBranchEnum();
    // this.getAgentEnumByUserRole()

    // this.getSlect()
  },
};
</script>
<style lang="scss">
.state-class {
  padding-left: 18px;
}

.textarea-cancel-class {
  width: 300px;
  padding-top: 10px;
}
.ss-hid {
  display: none;
}
.extendedForm {
  .query-input {
    width: 455px;
  }
  .date-time .el-date-editor {
    // width: 134px;
    width: 190px;
  }
  .date-time-check .el-date-editor{
    width: 180px;
  }
  // .select-class .el-input__suffix {
  //   width: 600px;
  // }
  .select-class-prod .el-input__inner {
    width: 210px;
  }
  .category-select-sale .el-input__inner {
    width: 210px;
  }
  .category-select  .el-input__inner{
    width: 210px;
  }
  .category-select .el-input__suffix{
    width: 60px;
  }
}
.approvalForm {
  .reason-input .el-input__inner {
    width: 300px;
  }
}
.approvalState-class .el-dialog__body {
  padding: 0px 20px;
}
</style>
